export default __webpack_public_path__ + "static/media/0078_IMG5001.f26d8034.jpg";